import Pill from "../common/Pill";
import AboutNavbar from "../about/AboutNavbar";

const HeroSection = () => {
  return (
    <section className="relative  bg-[#111219] overflow-hidden">
      <AboutNavbar />
      <div className="absolute inset-0 pointer-events-none">
        <div className="w-[150px] h-[150px] bg-red-600/60 blur-[70px] rounded-full absolute left-[200px] rotate-45 top-[50px]" />
        <div className="w-[150px] h-[900px] bg-red-600/60 blur-[150px] rounded-full absolute right-[300px] rotate-45 bottom-[-200px]" />
      </div>
      <div className="relative z-5 w-full max-w-6xl mx-auto px-4 pt-28 pb-20 md:pb-32">
        <div className="flex flex-col items-start text-left">
          <Pill text="help center" backgroundColor="#FFFFFF1A" />

          <h1
            className="text-[#E1E1E1] font-semibold
            text-[36px] leading-[48px]
            md:text-[52px] md:leading-[62px]
            mt-6"
          >
            We're Here to Help
          </h1>

          <p className="text-gray-300 text-sm md:text-base mt-4 max-w-lg">
            Find answers to any possible questions you may have. Still have questions? Reach to us using our contact form.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;